import { defineStore } from 'pinia'

/**
 * Converted from store/pageParams.js.
 *
 * Both Vuex getters duplicated same-named state fields and are gone — in Pinia a
 * getter shadows a same-named state key and makes it readonly. The field names
 * are the ones kept, since this module is persisted and they name entries in the
 * stored blob.
 *
 * `isExpiredSession` loses its `=== true` coercion in the process. That is a
 * no-op here: the only writers are the two actions below, which set the literal
 * true and false.
 */
export const usePageParamsStore = defineStore('pageParams', {
  state: () => ({
    isExpiredSession: false,
    lastPath: '',
  }),
  actions: {
    setIsExpiredSession(): void {
      this.isExpiredSession = true
    },
    clearIsExpiredSession(): void {
      this.isExpiredSession = false
    },
    setLastRoute(routeName: string): void {
      this.lastPath = routeName
    },
  },
})
